import React from 'react'
import { Form } from 'semantic-ui-react'

export default class RatingField extends React.PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Input
        fluid
        label="Rating Star"
        placeholder="e.g 5"
        required
        min="0"
        max="5"
        type="number"
        onChange={e => onChange('rate', e.target.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/ratingField.js